<template>
  <div id="th-loading">
    <div id="th-spinner" />
  </div>
</template>

<script>
import auth from '@shared/plugins/auth'

export default {
  name: 'Keycloak2FAPopup',

  created() {
    // If this is a popup window, handle 2FA login automatically
    this.handle2FALogin()
  },

  methods: {
    async handle2FALogin() {
      try {
        await auth.getSessionTwoFA()
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to initiate 2FA login:', error)
      }
    }
  }
}
</script>
